

import { defineComponent, PropType } from 'vue';
import { NDatePicker, NAlert } from 'naive-ui';
import { mapState, mapStores } from 'pinia';
import moment from 'moment';

import ModalBase from '~/components/modals/modal-base';
import { useStationStore } from '~/store/station.store';
import { useConfigStore } from '~/store/configuration.store';
import { http } from '~/api/api-http';
import { Station } from '~/api/models/station.model';

enum FileType {
    JSON = 'json',
    CSV = 'csv'
}

export default defineComponent({
    extends: ModalBase,

    components: {
        NDatePicker,
        NAlert,
    },

    props: {
        station: { type: Object as PropType<Station>, required: true },
    },

    computed: {
        ...mapStores(useConfigStore),

        filename() {
            if(!this.station) {
                return '';
            }

            const start = moment.unix(this.dateRange[0] / 1000);
            const end = moment.unix(this.dateRange[1] / 1000);

            return `measures-${this.station.name.toLowerCase()}_${start.format('YYYY-MM-DD')}_${end.format('YYYY-MM-DD')}.${this.selectedFileType}`;
        }
    },

    data() {
        const start = moment().subtract(1, 'w').unix() * 1000;
        const end = moment().unix() * 1000;
        return {
            fileTypes: [FileType.JSON, FileType.CSV],
            selectedFileType: FileType.CSV,
            valid: true,
            dateRange: [start, end] as [number, number],
            failure: false,
        }
    },

    methods: {
        submit(): void {

            if(!this.station) {
                return;
            }

            if(this.selectedFileType || !this.dateRange) {
                this.valid = false;
            }

            const since: number = Math.floor(this.dateRange[0]) / 1000;
            const before: number = Math.floor(this.dateRange[1]) / 1000;

            const uri: string = `/api/stations/${this.station.id}/measures?since=${since}&before=${before}&format=${this.selectedFileType}`;
            this.downloadUri(uri);

            if(!this.failure) {
                this.close();
            }
        },

        async downloadUri(uri: string, name: string = 'measures.csv'): Promise<void> {
            try {
                this.failure = false;
                await http.get(uri, { responseType: 'blob' })
                    .then(response => {
                        const blob = new Blob([response.data], { type: `application/${this.selectedFileType}` })
                        const link = document.createElement('a')
                        link.href = URL.createObjectURL(blob)
                        link.download = this.filename;
                        link.click()
                        URL.revokeObjectURL(link.href)
                    });
            } catch(e) {
                this.failure = true;
            }
        }
    },
});
